<app-expansion-panel title="Available Resources">
  <div class="resources-count" *ngIf="resources.length && resources[0].s3Key != ''">
    Total Resources: {{ resources.length }}
  </div>
  <div class="resources-container"  [ngClass]="{ 'grid-3-cols': resources.length > 2 }">
    <ng-container *ngIf="(resources.length === 1 && (!resources[0].url || resources[0].s3Key === '')); else resourceList">
      <div class="resource-not-found">Resource not found</div>
    </ng-container>
    <ng-template #resourceList>
      <mat-card *ngFor="let resource of resources" class="resource-card">
         <span class="resource-card-url" [class.disabled]="!resource.url" (click)="resource.url && openModal(resource)">
        <mat-icon class="resource-card-icon">picture_as_pdf</mat-icon>
        <mat-card-title class="resource-card-title">{{ resource.title }}</mat-card-title>
        </span>
      </mat-card>
    </ng-template>
  </div>
</app-expansion-panel>
